// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as historyActionCreators from '../../actions/history';
import { resetPreviousPage } from '../../actions/previouspages';
import deferComponentRender from '../../hocs/deferComponentRender';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import { Routes } from '../../types/routes';

import History from './History';
import selectHistoryProps from './History.selector';

const HistoryContainer = () => {
  const selectorProps = useMemo(() => ({ route: Routes.HISTORY }), []);
  const selectedProps = useSelector((state) => selectHistoryProps(state, selectorProps));

  const resetPosition = useCallback(() => resetPreviousPage(Routes.HISTORY), []);

  const actions = useMemo(() => ({ ...historyActionCreators, resetPosition }), [resetPosition]);
  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return <History {...enhancedProps} />;
};

export default deferComponentRender(HistoryContainer);
